import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LoadingConstants from 'app/shared/constants/LoadingConstants';
import propertyUtils from 'app/shared/utils/propertyUtils';

// Multibrand-UI Components
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';

// styles
import './style.scss';

const noop = () => { };

const propTypes = {
    properties: PropTypes.array,
    onLoadProperties: PropTypes.func,
    isLoading: PropTypes.bool,
};

const defaultProps = {
    properties: [],
    onLoadProperties: noop,
    isLoading: false,
};

const UserManagementPropertyListModal = ({
    properties,
    onLoadProperties,
    isLoading,
}) => {
    const formattedProperties = properties.map(property => propertyUtils.formatAddress(property));

    React.useEffect(() => {
        onLoadProperties();
    }, []);

    return (
        <div className="UserManagementPropertyListModal">
            {isLoading
                ? <SpinnerContainer />
                : formattedProperties.map((property, i) => (
                    <Text key={i} type="h4" className={i % 2 === 0 ? 'odd' : ''}>
                        {property.formattedName && `${property.formattedName} `}
                        {property.formattedAddress}
                    </Text>
                ))
            }
        </div>
    );
};

UserManagementPropertyListModal.propTypes = propTypes;
UserManagementPropertyListModal.defaultProps = defaultProps;

const mapStateToProps = state => ({
    properties: state.userManagement.currentUser.properties,
    isLoading: state.userManagement.currentUser.propertiesLoadingState === LoadingConstants.LOADING,
});

export default connect(mapStateToProps)(UserManagementPropertyListModal);
